<template>
  <div>
    <div v-if="vipList.length == 0 && otherList.length == 0" style="text-align: center;font-size: 30px;line-height: 56px;">
      <img src="@/assets/images/default/暂无任何数据.png" style="display: inline-block; vertical-align: middle; cursor: pointer;">
        <span class="nodata1">暂无数据</span>
    </div>
    <template v-else>
      <div class="background">
        <span class="title"></span>&nbsp;
        <span class="tips">软件服务升级</span>
      </div>
      <div class="list-box">
        <card v-for="(item,index) in vipList" :key="index" :item="item"></card>
      </div>
      <div class="background">
        <span class="title"></span>&nbsp;
        <span class="tips">其他</span>
      </div>
      <div class="list-box">
        <card v-for="(item,index) in otherList" :key="index" :item="item" :showDate="false"></card>
      </div>
      </template>
  </div>
</template>

<script>
import card from "./card.vue";

import {getServiceList} from "@/api/backstage/addService.js";

export default {
name: '' ,
components: {
  card
},
props:{},
data() {
return {
  vipList:[
    // {
    //   title:'3天高级版升级服务',
    //   endTime:'2023-12-31',
    //   startTime:'2023-12-12',
    //   price:'￥1000.00',
    //   day:'3day',
    //   limit:true,
    // },
    // {
    //   title:'30天高级版升级服务',
    //   endTime:'2023-12-31',
    //   startTime:'2023-12-28',
    //   price:'￥2000.00',
    //   day:'30day',
    //   limit:false,
    // }
  ],
  otherList:[
    // {
    //   title:'3天高级版升级服务',
    //   endTime:'2023-12-31',
    //   startTime:'2023-12-12',
    //   price:'￥1000.00',
    //   day:'3day',
    //   limit:false,
    // },
    // {
    //   title:'30天高级版升级服务',
    //   endTime:'2023-12-31',
    //   startTime:'2023-12-28',
    //   price:'￥2000.00',
    //   day:'30day',
    //   limit:false,
    // }
  ],
}
},
computed: {},
created() {

},
mounted() {
  this.getList();
},
methods: {
  getList(){
    getServiceList({type:4}).then(res=>{

      if(res.code == 1){
        res.data.forEach(item => {
          if(item.serviceType == 1){
            this.otherList.push(item)
          }else{
            this.vipList.push(item)
          }
        });
      }else{
        this.$message.error(res.message)
      }
    })
  }
}
}
</script>
<style lang='scss' scoped>
.list-box{
  display: flex;
  flex-wrap: wrap;
}

.background {
  height: 32px;
  background: rgba(250, 250, 250, 1);
  opacity: 1;
  line-height: 32px;
  padding-left: 12px;
  margin: 20px 0 0 0;
  margin-bottom: 20px;
  .title {
    display: inline-block;
    width: 2px;
    height: 14px;
    background: rgba(254, 77, 69, 1);
    opacity: 1;
    border-radius: 3px;
    vertical-align: middle;
  }
  .tips {
    width: 56px;
    height: 20px;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    color: rgba(51, 51, 51, 1);
    opacity: 1;
    vertical-align: middle;
  }
}
</style>